import { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import { GetNotification, MarkNotification, FollowUser } from "../services/api";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { decrementNotification } from "../features/notification/notificationSlice";
import { getMediaUrl, getProfileImage } from "../utils/helpers";

export default function Notifications({ open, onClose }) {

  const [notificationData, setNotificationData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {

    if (!open) return;

    GetNotification()
      .then((res) => {
        setNotificationData(res.data);
      })
      .catch((err) => {
        console.log(err)
      });

  }, [open]);

  const OnNotificationClick = async (notificationItem) => {
    try {
      const notificationId = notificationItem?._id;
      const markNotificationRes = await MarkNotification(notificationId);

      dispatch(decrementNotification());

      navigate(`/user/${notificationItem?.data?.userId}`)

      setNotificationData((prev) =>
        prev.filter((item) => item._id !== notificationId)
      );
    } catch (err) {
      console.log(err);
    }
  };

  const OnFollowClick = async (e, item) => {
    e.stopPropagation(); // 🛑 prevent notification click

    try {
      await FollowUser(item?.data?.userId);

      await MarkNotification(item?._id);

      dispatch(decrementNotification());

      // ✅ Update only that notification
      setNotificationData((prev) =>
        prev.map((n) =>
          n._id === item?._id
            ? {
              ...n, data: {
                ...n.data,
                isFollowing: true,
              }
            }
            : n
        )
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {/* ✅ BACKDROP */}
      {open && (
        <div onClick={onClose} className="fixed inset-0 bg-black/40 z-[999]" />
      )}

      {/* ✅ PANEL */}
      <div
        className={`
          fixed top-[72px] right-0
          w-full sm:w-[380px] md:w-[420px] lg:w-[480px]
          bg-black border-l border-gray-800
          z-[1000] flex flex-col
          transition-transform duration-300 ease-in-out
          ${open ? "translate-x-0" : "translate-x-full"}
        `}
        style={{
          height: "calc(100dvh - 72px)", // ✅ REAL mobile height fix
        }}
      >
        {/* ✅ HEADER */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-800 shrink-0">
          <h2 className="text-white text-lg font-semibold">Notifications</h2>
          <button onClick={onClose} className="text-white text-2xl">
            <IoClose />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-1">

          {notificationData.length === 0 ? (
            <div className="h-full flex items-center justify-center">
              <p className="text-gray-400 text-lg">No Notifications</p>
            </div>
          ) : (
            <div className="divide-y divide-gray-800">
              {notificationData.map((item) => (
                <div
                  key={item._id}
                  onClick={() => OnNotificationClick(item)}
                  className="flex items-center justify-between px-5 py-4 hover:bg-gray-900 transition"
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={getProfileImage(getMediaUrl(item?.data?.ppImageURL))}
                      alt={item?.data?.name}
                      className="w-12 h-12 rounded-full object-cover"
                    />

                    <div>
                      <div className="flex items-center gap-1">
                        <h3 className="text-white font-semibold">
                          {item?.data?.name}
                        </h3>
                        {item?.data?.is_verified && (
                          <span className="text-blue-500 text-sm">✔</span>
                        )}
                      </div>
                      <p className="text-gray-400 text-sm">{item?.message}</p>
                    </div>
                  </div>

                  {!item?.data?.isFollowing && (
                    <button
                      onClick={(e) => OnFollowClick(e, item)}
                      className="border border-gray-600 text-white px-4 py-1.5 rounded-full text-sm hover:bg-gray-800 transition shrink-0"
                    >
                      + Follow
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
